var character = "ကိုယ်စားပြုစာလုံး";
var copied = "ကူးယူထားပြီး";
var copy = "ကူးယူမယ်";
var insert = "ထည့်မည်။";
var loading = "ခဏစောင့်ပါ";
var orCopyLink = "သို့ လင့်ကို ကူးယူမည်။";
var submit = "တင်မည်။";
var myTranslations = {
	"actionPopover.delete": "ဖျက်မယ်။",
	"actionPopover.deleteNotification": "ဒီအသိပေးချက်ကို ဖျက်မယ်။",
	"actionPopover.edit": "ပြုပြင်မယ်။",
	"actionPopover.inviteShareCommunity": "အဖွဲ့အစည်းကို ဖိတ်ခေါ်မယ်/ မျှဝေမယ်။",
	"actionPopover.joinCommunity": "အဖွဲ့အစည်းတွင် ပါဝင်မယ်။",
	"actionPopover.leaveCommunit": "အဖွဲ့အစည်းမှ ထွက်မယ်။",
	"actionPopover.leaveCommunity": "အဖွဲ့အစည်းမှ ထွက်မယ်။",
	"actionPopover.leaveCommunity.accept": "ထွက်မည်။",
	"actionPopover.leaveCommunity.cancel": "ပယ်ဖျက်မည်။",
	"actionPopover.leaveCommunity.description": "ဒီအဖွဲ့အစည်းက ထွက်လိုတာ သေချာပါပြီလား။",
	"actionPopover.leaveCommunity.title": "အဖွဲ့အစည်းမှ ထွက်မယ်။",
	"actionPopover.report": "တိုင်ကြားမယ်။",
	"actionPopover.turnOffNotification": "အသိပေးချက်ကို ပိတ်မယ်။",
	"actionPopover.turnOffNotificationAbout": "{label}အကြောင်း အသိပေးချက်ကို ပိတ်မယ်။",
	"actionPopover.turnOnNotification": "အသိပေးချက်ကို ဖွင့်မယ်။",
	"adBanner.title": "advertisement",
	"admin.comments": "မှတ်ချက်များ",
	"admin.communities": "အဖွဲ့အစည်းများ",
	"admin.community": "အဖွဲ့အစည်း",
	"article.shareOn": "မျှဝေမည်။",
	"articleAuthor.title.expert": "Expertly reviewed by",
	"articleAuthor.title.fact-check": "{name} မှ အချက်အလက် စစ်ဆေးထားပါသည်။",
	"articleAuthor.title.medical": "Medically reviewed by",
	"articleAuthor.title.written-by": "Written by",
	"articlePage.articleReviewerBy": "{name} မှ ဆေးပညာပိုင်းဆိုင်ရာ တည်းဖြတ်ခဲ့သည်။",
	"articlePage.readMore": "နောက်ထပ် ဖတ်ရှုမည်",
	"articlePage.showLess": "ဆက်လက်မကြည့်လိုပါ။",
	"babyGrowth.alert.bmi": "WHO ရဲ့ အချက်အလက်တွေထဲမှာ မွေးကင်းစကနေ အသက် ၅ နှစ်ကြားအရွယ် ကလေးတွေအတွက် BMI မရှိတာကြောင့်  {name}အတွက် BMI ရလဒ် မရရှိနိုင်ပါ။ အသက် ၅ နှစ်အထက် ကလေးတွေအတွက် BMI တွက်ချက်မှုကိရိယာကို အသုံးပြုပေးလို့ ရပါတယ်။  ",
	"babyGrowth.alert.head": "WHO ရဲ့ အချက်အလက်တွေထဲမှာ မွေးကင်းစကနေ အသက် ၅ နှစ်ကြားအရွယ် ကလေးတွေအတွက် ဦးခေါင်းအတိုင်းအတာ သတ်မှတ်ချက် မရှိတာကြောင့်  {name}အတွက် ဦးခေါင်းအတိုင်းအတာ သတ်မှတ်ချက် မရရှိနိုင်ပါ။ ",
	"babyGrowth.alert.weight": "WHO ရဲ့ အချက်အလက်တွေထဲမှာ မွေးကင်းစကနေ အသက် ၁၀ နှစ်ကြားအရွယ် ကလေးတွေအတွက် ကိုယ်အလေးချိန် အတိုင်းအတာ သတ်မှတ်ချက် မရှိတာကြောင့်  {name}အတွက် ကိုယ်အလေးချိန်အတိုင်းအတာ သတ်မှတ်ချက် မရရှိနိုင်ပါ။ ",
	"babyGrowth.babyInfo": "ကလေး၏ အချက်အလက်",
	"babyGrowth.chartTitle": "WHO - {name} ရဲ့ဖွံ့ဖြိုးမှုပြ ဇယား",
	"babyGrowth.chartTitle.noName": "သင့်ကလေးရဲ့ ဖွံ့ဖြိုးမှုပြ ဇယား",
	"babyGrowth.cm": "cm",
	"babyGrowth.drawer.addMeasurement": "အတိုင်းအတာဖြည့်မည်။",
	"babyGrowth.drawer.createBaby": "ကလေးရဲ့ ကိုယ်ရေးအကျဉ်းကို ဖန်တီးမည်။",
	"babyGrowth.drawer.switchProfile": "ကိုယ်ရေးအကျဉ်းလဲမည်။",
	"babyGrowth.emptyName": "သင့်ရဲ့ ကလေး",
	"babyGrowth.error.atLeastOneOf": "အထက်ပါ ဖော်ပြမှုများထဲက ကိုယ်အလေးချိန်၊ အရပ်၊ ဦးခေါင်း အတိုင်းအတာ သတ်မှတ်ချက် တစ်ခုခုကို ဖြည့်သွင်းပေးဖို့ လိုအပ်ပါမယ်။",
	"babyGrowth.error.birthdayRequired": "မွေးနေ့ ဖြည့်သွင်းပေးပါရန်",
	"babyGrowth.error.invalidAge": "ဖြည့်သွင်းထားတဲ့ အတိုင်းအတာက အသက်အရွယ်ထက် ကျော်လွန်နေပါတယ်။",
	"babyGrowth.error.invalidMeasurementDate": "တိုင်းတာတဲ့ရက်က မှားယွင်းနေပါတယ်။",
	"babyGrowth.error.invalidValue": "ကျေးဇူပြုပြီး အတိုင်းအတာကို မှန်ကန်စွာ ဖြည့်သွင်းပေးပါ။",
	"babyGrowth.error.measurementDateLowerThanBirthday": "ဖြည့်သွင်းထားတဲ့ မွေးနေ့က ကလေးမွေးနေ့ မရောက်ခင် ရက် ဖြစ်နေပါတယ်။",
	"babyGrowth.error.outOfRange": "အတိုင်းအတာတွေက WHO ရဲ့ အတိုင်းအတာတွေထက် ကျော်လွန်နေပါတယ်။",
	"babyGrowth.error.title": "အချက်အလက်တွေက မှားယွင်းနေပါတယ်။",
	"babyGrowth.head": "ဦးခေါင်း",
	"babyGrowth.headCircumference": "ဦးခေါင်း အတိုင်းအတာ",
	"babyGrowth.height": "အရပ်",
	"babyGrowth.input.babyName": "ကလေးရဲ့ နာမည်",
	"babyGrowth.input.birthday": "ကလေးရဲ့ မွေးနေ့",
	"babyGrowth.input.bmi": "ကလေးရဲ့ ကိုယ်အလေးချိန်",
	"babyGrowth.input.bodyMass": "ကလေးရဲ့ ကိုယ်အလေးချိန်",
	"babyGrowth.input.checkSubmit": "ကလေးရဲ့ ဖွံ့ဖြိုးမှုကို စစ်ဆေးပါ",
	"babyGrowth.input.measurementDate": "တိုင်းတာသည့် ရက်စွဲ",
	"babyGrowth.input.submit": "ကလေးရဲ့ ဖွံ့ဖြိုးမှုကို စစ်ဆေးပါ",
	"babyGrowth.kg": "kg",
	"babyGrowth.kg.m2": "kg/m2",
	"babyGrowth.monthly": "လအလိုက်",
	"babyGrowth.nickname": "သို့မဟုတ် အိမ်ခေါ်နာမည်",
	"babyGrowth.optional": "(နှစ်သက်ရာ)",
	"babyGrowth.pageTitle": "ကလေးရဲ့ ဖွံ့ဖြိုးမှုရလဒ်",
	"babyGrowth.percentiles": "ဖွံ့ဖြိုးမှုပြ ဇယားဖြင့်",
	"babyGrowth.placeholder.babyName": "ကလေးရဲ့ နာမည်ကို ဖြည့်သွင်းပါ",
	"babyGrowth.popup.heading": "Baby's Profile",
	"babyGrowth.reCalculate": "ပြန်လည်တွက်ချက်မည်",
	"babyGrowth.record": "မှတ်တမ်းများ",
	"babyGrowth.save": "အတိုင်းအတာများကို သိမ်းဆည်းမည်",
	"babyGrowth.save.loggedIn": "{name} ရဲ့ဖွံ့ဖြိုးမှုပြ ဇယား",
	"babyGrowth.weekly": "အပတ်အလိုက်",
	"babyGrowth.weight": "ကိုယ်အလေးချိန်",
	"babyGrowth.xLabel": "အသက် ({recurrence})",
	"babyGrowth.yearly": "နှစ်အလိုက်",
	"babyPoop.findOut": "ရှာဖွေမည်။",
	"babyPoopTool.name": "Baby Poop",
	"babyVaccine.banner.readmore": "ဆက်လက်ဖတ်ရှုရန်",
	"babyVaccine.detail.benifit": "အကျိုးအပြည့်အဝ",
	"babyVaccine.detail.contraindication": "အသုံးပြုရန်မလိုအပ်သောအချက်များ",
	"babyVaccine.detail.definition": "အကြောင်းအရာအနုပညာများ",
	"babyVaccine.detail.relatedArticles": "ဆက်စပ်သောအကြောင်းအရာ",
	"babyVaccine.immunization.vaccineName": "ကာကွယ်ဆေးအမည်",
	"babyVaccine.immunization.warning": "ကာကွယ်ဆေးထိုးဇယားသည် သင့်ကလေးတကယ်ထိုးရသည့် ကာကွယ်ဆေးထိုးအချိန်ဇယားနှင့် ဆင်တူသောကြောင့် ဖတ်ရလွယ်ပြီး မိဘများအတွက်  အဆင်ပြေပါသည်။",
	"babyVaccine.popup.button": "Create a new profile",
	"babyVaccine.popup.button.submit": "သိမ်းဆည်းမည်။",
	"babyVaccine.popup.checkbox.suggestedDate": "ဆေးထိုးရန် ရက်ရွေးပါ။ ဒါမှမဟုတ် အကြံပြုထားတဲ့ရက်ကို ရွေးပါ။",
	"babyVaccine.popup.confirm.close": "ရက်ပြောင်းလဲမည်။",
	"babyVaccine.popup.confirm.description": "သင့်ကလေးသည် ဤကာကွယ်ဆေးကို {date}တွင် ထိုးခဲ့ပါသည်။",
	"babyVaccine.popup.confirm.ok": "အတည်ပြုမည်။",
	"babyVaccine.popup.confirm.title": "ကာကွယ်ဆေးထိုးရမည့်နေ့",
	"babyVaccine.popup.input.suggestedDate": "မမှတ်မိပါ/ အကြံပြုထားသောရက်အတိုင်း ထည့်ပေးပါ။",
	"babyVaccine.popup.label.doses": "အကြိမ်ရေ",
	"babyVaccine.popup.tab.benefits": "ကောင်းကျိုးများ",
	"babyVaccine.popup.tab.contraindication": "မထိုးသင့်သော အခြေအနေ",
	"babyVaccine.popup.tab.detail": "အသေးစိတ် အချက်အလက်များ",
	"babyVaccine.popup.tab.schedule": "စစ်ဆေးခြင်း",
	"babyVaccine.popup.title": "ကာကွယ်ဆေးအကြောင်း",
	"babyVaccine.status.all": "အားလုံး",
	"babyVaccine.status.missed": "ကျော်လွန်သွားသော",
	"babyVaccine.status.next": "Next",
	"babyVaccine.status.upcoming": "ထပ်မံ၍",
	"babyVaccine.status.vaccinated": "ကာကွယ်ဆေးထိုးပြီး",
	"babyVaccine.timeline.antigen": "ပါဝင်ပစ္စည်း :",
	"babyVaccine.timeline.atBirth": "မွေးကင်းစ",
	"babyVaccine.timeline.total": "စုစုပေါင်း : {number} ကြိမ်",
	"babyVaccine.timeline.totalNext": "နောက်ထပ်ထိုးရမယ့် ကာကွယ်ဆေး  {number} ကြိမ်",
	"babyVaccine.timeline.totalPast": "ပြီးခဲ့သော ကာကွယ်ဆေး  {number} ကြိမ်",
	"babyVaccine.vaccineCard.injected": "ထိုးပြီး",
	"babyVaccine.vaccineCard.markAsInjected": "ထိုးပြီဟု မှတ်ပြီး",
	"babyVaccine.vaccineInfo.dose": "အကြိမ်ရေ :  {ordinal}ကြိမ်မြောက်/စုစုပေါင်း အကြိမ်ရေ{total}",
	"babyVaccine.vaccineInfo.injectedDate": "ဆေးထိုးသည့်နေ့ : {date}",
	"babyVaccine.vaccineInfo.mandatory": "မဖြစ်မနေ",
	"babyVaccine.vaccineInfo.optional": "ထိုးနိုင်လျှင်ကောင်း",
	"babyVaccine.vaccineInfo.suggested": "အကြံပြုလိုသောရက်: {date}",
	"babyVaccineTool.heading": "ကလေးကာကွယ်ဆေးထိုး အချိန်ဇယား",
	"bmi.ageInput": "အသက်ဘယ်လောက်ရှိပြီလဲ",
	"bmi.ageInput.desc": "(years)",
	"bmi.ageInput.error": "လက်ရှိအသက်ကို ဖြည့်သွင်းပါ",
	"bmi.heading": "ခန္ဓာကိုယ် ထုထည်ညွှန်းကိန်း တွက်ချက်ခြင်း (BMI) ။",
	"bmi.heightInput": "အရပ်အမြင့်",
	"bmi.heightInput.desc": "(ft)",
	"bmi.heightInput.error": "လက်ရှိ အရပ်ကို ဖြည့်သွင်းပါ",
	"bmi.objective": "ရည်ရွယ်ချက်",
	"bmi.objective.gainWeight": "ကြွက်သားတည်ဆောက်ခြင်း",
	"bmi.objective.loseWeight": "အဆီချခြင်း",
	"bmi.objective.maintainWeight": "ကိုယ်အလေးချိန် ထိန်းညှိခြင်း",
	"bmi.result.healthy": "ကျန်းမာပါသည်",
	"bmi.result.overweight": "ကိုယ်အလေးချိန် များနေသည်",
	"bmi.result.underweight": "ကိုယ်အလေးချိန် နည်းနေသည်။",
	"bmi.selectGender": "ကျား / မ",
	"bmi.submit": "တွက်ချက်ပါ",
	"bmi.weightInput": "ကိုယ်အလေးချိန် ",
	"bmi.weightInput.desc": "(lbs)",
	"bmi.weightInput.error": "လက်ရှိကိုယ်အလေးချိန်ကို ဖြည့်သွင်းပါ",
	"bmr.heading": "အခြေခံတစ်နေ့တာ ကယ်လ်လိုရီ လိုအပ်ချက်ပမာဏ တွက်ချက်ခြင်း ကိရိယာ (BMR)",
	"booking.searchBar.allLocations": "အားလုံးအနေနဲ့ ",
	"booking.searchBar.allSpecialties": "အားလုံးအကျယ်",
	"booking.searchBar.currentLocation": "Current location",
	"booking.searchBar.grantLocation": "Please grant location permission to search by current location",
	"booking.searchBar.locationPlaceholder": "Enter city",
	"booking.searchBar.noResults": "No Results",
	"booking.searchBar.placeholder.doctor": "Search by doctor name",
	"booking.searchBar.placeholder.hospital": "Search by hospital name",
	"booking.searchBar.placeholder.service": "Search by service",
	"booking.searchBar.placeholder.specialty": "Search by specialty",
	"booking.searchBar.popularKey": "ကျွန်ုပ်တို့ ရှောက်ရှောက်",
	"booking.searchBar.searchButton": "Search",
	"booking.searchBar.searchInput.placeholder": "Search by Specialty or Clinic...",
	"booking.searchBar.useCurrentLocation": "Use my current location",
	"booking.searchBar.viewAll": "အားလုံးကို ကျွန်ုပ်တို့",
	"booking.searchPopup.doctors": "Doctors",
	"booking.searchPopup.hospitals": "Hospitals & Clinics",
	"booking.searchPopup.searchIn.doctors": "Search \"{name}\" in Doctors",
	"booking.searchPopup.searchIn.hospitals": "Search \"{name}\" in Hospitals",
	"booking.searchPopup.searchIn.services": "See \"{name}\" in Services",
	"booking.searchPopup.searchIn.specialties": "Search \"{name}\" in Specialties",
	"booking.searchPopup.seeAll": "See All",
	"booking.searchPopup.seeLessSpecialties": "See less specialties",
	"booking.searchPopup.seeMoreSpecialties": "See more specialties",
	"booking.searchPopup.services": "Services",
	"booking.searchPopup.specialties": "Specialties",
	"booking.searchResult.description": "{search_type} တွင် {search_location}",
	"bottomBar.share": "မျှဝေမည်။",
	"cardAuthor.admin": "အက်မင်",
	"cardAuthor.ambassador": "ကိုယ်စားလှယ်",
	"cardAuthor.expert": "ကျွမ်းကျင်ပညာရှင်",
	"cardAuthor.guide": "လမ်းညွှန်ချက်",
	"cardAuthor.influencer": "Influencer",
	"cardAuthor.localAdmin": "အက်မင်",
	"cardAuthor.moderator": "မော်ဒရေတာ",
	"cardAuthor.sponsor": "စပွန်ဆာ",
	"cardPost.anonymous": "အမည်မသိ",
	"cardPost.option.anonymous": "အမည်မဖော်လိုသူ",
	"cardPost.public": "အများအပြား",
	"cardReactions.comment": "မှတ်ချက်",
	"cardReactions.like": "နှစ်သက်သည်",
	"cardReactions.repliesCount": "ပြန်ဖြေသည့်မှတ်ချက် {count}ခု",
	"cardReactions.reply": "အကြောင်းပြန်မယ်။",
	"cardReactions.save": "သိမ်းဆည်းမယ်။",
	"cardReactions.unSave": "မဖြစ်မှု",
	"cardReply.disclaimer": "<strong>Disclaimer:</strong> The content is furnished relying on authenticated information sources.",
	"cardReply.endorse": "Endorse",
	"cardReply.opposePopup.content": "Can you please provide the reasons for refuting this answer?",
	"cardReply.opposePopup.submit": "Submit",
	"cardReply.pppose": "Refute",
	"cardReply.recommentCategories.heading": "Related content",
	"cardReply.source": "Sources",
	"cardReply.verifyBy": "Medically reviewed by {name}",
	"careBooking.bookAnAppointment": "ဘိုကင် တင်မည်။",
	"categoryPage.info.reviewed": "ဆေးပညာပိုင်းဆိုင်ရာ စိစစ်သူ",
	"categoryPage.onDate": "နေ့စွဲ{date}",
	character: character,
	"chatbot.with.me": "Chat with me",
	"childCard.age.months": "{month} လ",
	"childCard.age.oneMonth": "1 လ",
	"childCard.age.oneWeek": "၁ ပတ်",
	"childCard.age.oneYear": "၁ နှစ်",
	"childCard.age.oneYearMonth": "၁ နှစ် {month} လ",
	"childCard.age.oneYearOneMonth": "၁ နှစ် ၁ လ",
	"childCard.age.week": "{weeks} ပတ်",
	"childCard.age.yearMonth": "{year} နှစ် {month} လ",
	"childCard.age.yearNoMonth": "{year} နှစ်",
	"childCard.age.yearOneMonth": "{year} နှစ် ၁ လ",
	"childCard.boy": "ယောက်ျားလေး",
	"childCard.girl": "မိန်းကလေး",
	"childCard.menu.add": "ကလေးကိုယ်ရေးအကျဉ်းကို လဲမည်။",
	"childCard.menu.edit": "{name}၏ ကိုယ်ရေးအကျဉ်းကို ပြင်ဆင်မည်။",
	"childCard.menu.remove": "{name}ရဲ့ ကိုယ်ရေးအကျဉ်းကို ဖယ်ရှားမည်။",
	"childCard.menu.switch": "ကလေးကိုယ်ရေးအကျဉ်းကို လဲမည်။",
	"childCard.noName": "ကလေးနာမည်",
	"choicePopover.ambassadorPosts": "ကိုယ်စားလှယ်ပို့စ်များ",
	"choicePopover.expertPosts": "ကျွမ်းကျင်ပညာရှင်ပို့စ်များ",
	"choicePopover.lastestPost": "နောက်ဆုံးပို့စ်များ",
	"choicePopover.latest": "နောက်ဆုံး",
	"choicePopover.newest": "အသစ်",
	"choicePopover.oldest": "အဟောင်း",
	"choicePopover.popular": "ပေါ်ပြူလာ",
	"choicePopover.popularPost": "ပေါ်ပြူလာပို့စ်များ",
	"choicePopover.sort": "အမျိုးအစား",
	"choose.community": "သင့်အတွက် အသိုင်းအဝိုင်း ရွေးချယ်ပါ",
	"choose.other.community": "အသိုင်းအဝိုင်းအခြားကို ရွေးချယ်ပါ",
	"chooseBaby.button": "သင့်ကလေးကြီးထွားမှုဇယားကို ကြည့်မည်။",
	"chooseBaby.new": "သို့မဟုတ် ကလေးရဲ့ ကိုယ်ရေးအကျဉ်းကို အသစ်ဖန်တီးမည်။",
	"chooseBaby.placeholder": "ကလေးအမည်ပေးပါ။",
	"chooseBaby.title": "ကလေးကိုယ်ရေးအကျဉ်းကို လဲမည်။",
	"comment.count": "မှတ်ချက် {count}ခု",
	"comment.now": "ယခုမှတ်ချက်ပေးပါ",
	"comment.seeMoreComments": "မှတ်ချက် {count}ခုကို ဆက်ကြည့်မယ်။ ",
	"comment.seeMoreReplies": "ပြန်လည်ဖြေကြားချက် {count}ခုကို ဆက်ကြည့်မယ်။",
	"commentPopup.warning.newPost": "သင့်မှတ်ချက်ကို လူတိုင်းက မြင်တွေ့နိုင်မည်။",
	"common.playing": "ခဏစောင့်ပါ",
	"common.profileNavigator.newsletterSubscription": "Newsletter Subscription",
	"common.sponsoredBy": "အားဖြည့်ကူညီပေးသူ",
	"common.totalView": "{number} ကြည့်ရှုမှု",
	"community.choose": "အဖွဲ့အစည်းတစ်ခုကို ရွေးပါ။",
	"community.notification.joined": "သင် {name} အဖွဲ့အစည်းတွင် ပါဝင်ပြီးပါပြီ။",
	"community.notification.left": "သင် {name} အဖွဲ့အစည်းမှ ထွက်လိုက်ပါပြီ။",
	copied: copied,
	copy: copy,
	"createPost.askDoctor": "ဆရာဝန်အား မေးမည်။",
	"createPost.askDoctor.description": "ကျွန်ုပ်တို့၏ ကျွမ်းကျင်သူများထံမှ အကြံဉာဏ်ရယူပါ",
	"createPost.askDoctorChoice.no": "No",
	"createPost.askDoctorChoice.yes": "Yes",
	"createPost.communityAndTopic": "လူမှုအဖွဲ့နှင့်ခေါင်းစဉ်",
	"createPost.message.askDoctorRequire": "Would you like to ask a question to our doctor?",
	"createPost.message.askDoctorRequireMess": "ကျေးဇူးပြု၍ ရွေးချယ်စရာကိုရွေးပါ",
	"createPost.message.lengthDescription": "ဖော်ပြချက်တွင် အနည်းဆုံး 10 စကားလုံးရှိရမည် | လက်ရှိ: {currentLength} စကားလုံး",
	"createPost.message.lengthTitle": "ခေါင်းစဉ်တွင်အနည်းဆုံး ၅ စကားလုံးရှိရမည်",
	"createPost.message.lengthTitle.characters": "ခေါင်းစဉ်တွင် အနည်းဆုံး ၅ မျိုးစာလုံးရပါမည်။",
	"createPost.message.photoMaxium": "ပို့စ်အတွက် ပုံများကိုတင်သည့်အခါ အများဆုံး 10 ပုံသာခွင့်ပြုသည်",
	"createPost.message.photoSize": "10 MB ထက်မကြီးသောပုံများကိုသာတင်ခွင့်ပြုသည်",
	"createPost.message.requiredDescription": "ဖော်ပြချက်လိုအပ်သည်",
	"createPost.message.requiredTitle": "ခေါင်းစဉ်လိုအပ်သည်",
	"createPost.message.suggestLoading": "ကျွန်ုပ်တို့သည်သင်၏ပို့စ်အတွက်သင့်တော်သောအသိုင်းအဝိုင်းကိုအကြံပြုနေပါသည်။",
	"createPost.message.suggestResult": "သင့်အနေဖြင့် ယခုမှ ပို့စ်တင်နိုင်ပါပြီ! ကျွန်ုပ်တို့သည် အပြီးသတ် ထိုကွင်းဆက်ကို စတင်ပြီး သင့်တော်သော အသိုင်းအဝိုင်းကို ရှာဖွေမှာဖြစ်ပါသည်။",
	"createPost.now": "ယခုမှ ပို့စ်တင်ပါ",
	"createPost.photos": "ဓာတ်ပုံများ",
	"createPost.popup.description": "ဖော်ပြချက်",
	"createPost.popup.guideSelectMonthTopics": "သင့်ကလေးမွေးဖွားလနှင့်ပတ်သက်သော အကြောင်းအရာများကို ရွေးချယ်ပါ။",
	"createPost.popup.guideSelectTopics": "သင့်ဆောင်းပါးများကို ပို့စ်တင်ရမည့်နေရာကို ရွေးချယ်ပါ။",
	"createPost.popup.primary": "ခေါင်းစဉ်များကို ရွေးရန်/ မရွေးလိုပါက နှိပ်ပါ။",
	"createPost.popup.selectMonthTopicBtn": "ရွေးချယ်ပါ။",
	"createPost.popup.specialCharErr": "သင်ထည့်သွင်းထားသော ခေါင်းစဉ်သည် မမှန်ကန်ပါ။ ခေါင်းစဉ်များတွင် စာလုံးများ ပါရှိရမည်။",
	"createPost.popup.submit": "ပို့စ်",
	"createPost.popup.success": "ပို့စ်အသစ်ဖန်တီးပြီး",
	"createPost.popup.warning": "သင်စောင့်ကြည့်နေသော ခေါင်းစဉ်များကို ကြည့်ရန် အဖွဲ့အစည်းကို ရွေးပါ။",
	"createPost.popup.warningImage": "အများဆုံး ၃ပုံသာ လက်ခံပါတယ်။ အောက်က တချို့အရာတွေကို ဖယ်ရှားပေးပါ။",
	"createPost.popup.wordCount": "{count}/{max} လုံး",
	"createPost.post.askDoctor.description": "လက္ရွိရရွိေသာရောဂါလက္မှတ်",
	"createPost.post.askDoctor.title": "ရောဂါလက္မှတ်အမည်",
	"createPost.post.description": "ပို့စ်ဖော်ပြချက်",
	"createPost.post.title": "ပို့စ်ခေါင်းစဉ်",
	"createPost.postAnonymous": "အမည်မသိသူမှ ပို့စ်တင်ရန်",
	"createPost.title": "ခေါင်းစဉ်",
	"createPost.urlText": "စာသား",
	"createPost.video": "ဗီဒီယို",
	"createPost.videoOrLink": "ဗီဒီယို သို့မဟုတ် link",
	"dueDatePage.IUI": "သားအိမ်အတွင်းသုက်ထိုးခြင်း (IUI)",
	"dueDatePage.calculationMethod": "တွက်ချက်နည်း",
	"dueDatePage.conceptionDate": "ကိုယ်ဝန်ရရှိသည့် ရက်စွဲ",
	"dueDatePage.date_of_IUI_procedure": "IUI လုပ်ထုံးလုပ်နည်းရက်",
	"dueDatePage.date_of_ultrasound": "အလ်ထရာဆောင်းရက်",
	"dueDatePage.daysText": "{number} ရက်",
	"dueDatePage.ivf": "ဖန်ပြွန်သန္ဓေသား",
	"dueDatePage.ivf.transferDate": "သန္ဓေသား ပြောင်းထည့်သည့်ရက်",
	"dueDatePage.ivf.transferDateRadio": "{number}-ပြောင်းထည့်သည့်ရက်",
	"dueDatePage.lastPeriod": "နောက်ဆုံးရာသီလာတဲ့ ရက်",
	"dueDatePage.lastPeriod.calculate": "တွက်ချက်မည်",
	"dueDatePage.lastPeriod.lastPeriodLabel": "နောက်ဆုံးရာသီစက်ဝန်းရဲ့ ပထမရက်",
	"dueDatePage.lastPeriod.periodLengthLabel": "ရာသီစက်ဝန်း ကြာချိန်",
	"dueDatePage.ultrasound": "Ultrasound",
	"dueDatePage.ultrasound.tooltip": "Mean sac Diameter (MSD) is less accurate than Crown-Rump Length (CRL) for dating a pregnancy. It is only used in very early pregnancy, between 4 and 6 weeks.",
	"dueDatePage.validation.crl": "MSD တန်ဖိုးမမှန်ကန်ပါ။ ဆက်လက်လုပ်ဆောင်ရန် CRL အညွှန်းကို ထည့်ပါ။",
	"dueDatePage.validation.one_is_required": "အနည်းဆုံးတစ်ခုလိုအပ်သည်",
	"dueDatePage.validation.record_not_valid": "Your recorded isn't valid!",
	"editor.addSocialLink.addLink": "ထည့်ပါ",
	"editor.addSocialLink.warningDomain": "Youtube, Facebook နှင့် Tiktok မှ ရင်းမြစ်များကိုသာခွင့်ပြုသည်",
	"expert.content.description": "ကျွမ်းကျင်သူ ကိုယ်ရေးအကျဉ်း",
	"expert.content.experiences": "အတွေ့အကြုံများ",
	"footer.signUp": "စာရင်းပေးသွင်းလိုက်ပါ",
	"gender.boy": "ယောက်ျားလေး",
	"gender.female": "အမျိုးသမီး",
	"gender.girl": "မိန်းကလေး",
	"gender.male": "အမျိုးသား",
	"healthToolPNModal.back": "Back",
	"healthToolPNModal.findMore.chooseFav": "Choose from your favorite topics\n",
	"healthToolPNModal.finish": "ပြီးပါပြီ၊၊",
	"healthToolPNModal.heading": "Nhận bản tin miễn phí mỗi tuần?",
	"healthToolPNModal.mainForm.requireName": "Please enter your name",
	"healthToolPNModal.mainForm.tailorTopicsHeading": "These topics are tailored to your result",
	"healthToolPNModal.next": "Next",
	"healthToolPNModal.register": "Register",
	"healthToolPNModal.yourPre": "Your preferences",
	"healthTools.dueDateCalculator": "မွေးဖွားမယ့်ရက် တွက်ချက်ခြင်း",
	"healthTools.ovulationCalculator": "သားဥကြွေခြင်းကို တွက်ချက်ခြင်း",
	"healthtool.placeholder.age": "သင့်အသက်",
	"home.calcWithApp": "Calculate on Hello Bacsi app",
	"home.menu.category.view": "{category} ကို ကြည့်မည်။",
	"home.navigator.app": "App",
	"home.navigator.downloadApp": "Download App",
	"home.navigator.menu.care.homeButton": "Booking Home",
	"home.navigator.menu.care.noDatas.cta": "Book a Doctor",
	"home.navigator.menu.care.noDatas.description": "HelloCare helps patients to find the right medical doctors and service treatment for their needs, in their vicinity.",
	"home.navigator.menu.care.noDatas.title": "Make an appointment with doctors easily",
	"home.navigator.menu.category.noDatas.cta": "Discover now",
	"home.navigator.menu.category.noDatas.description": "Hello Doctor wants to be your most trusted ally to make more informed decisions and to live healthier and happier lives.",
	"home.navigator.menu.category.noDatas.title": "Welcome to Hello Doctor",
	"home.navigator.menu.healthTools.noDatas.cta": "Discover more",
	"home.navigator.menu.healthTools.noDatas.description": "These easy-to-use health assessment tools will help you gauge vital parts of your overall health and wellness.",
	"home.navigator.menu.healthTools.noDatas.title": "Health Tools",
	"home.navigator.menu.lastestVideos": "နောက်ဆုံးဗီဒီယိုတိုများ",
	"home.navigator.menu.podcasts": "ပေါ့ဒ်ကတ်စ်",
	"home.navigator.menu.shorts": "ဗီဒီယိုတိုများ",
	"home.navigator.menu.spotlightEcom": "Categories",
	"home.navigator.menu.spotlightHospitals": "အရှာများသောဆေးရုံများ",
	"home.navigator.menu.spotlightTools": "နှစ်သက်သည့်ကိရိယာများ",
	"home.navigator.menu.spotlights": "အာရုံစိုက်ရမည့် အကြောင်းအရာ",
	"home.navigator.menu.spotlights.seeAll": "အာရုံစိုက်ရမည့် အကြောင်းအရာများကို ကြည့်ရန်",
	"home.navigator.menu.together.noPosts.cta": "အဖွဲ့အစည်းများတွင် ပါဝင်မည်။",
	"home.navigator.menu.together.noPosts.description": "အဖွဲ့အစည်းများတွင် သင်သိလိုသော ကျန်းမာရေးပြဿနာများကို ကျွမ်းကျင်ပညာရှင်များထံမှ အကြံဉာဏ်ရယူနိုင်ခြင်း၊ သင်စိတ်ဝင်စားသော အကြောင်းအရာများကို မှတ်ချက်ပေးနိုင်ခြင်း၊ တခြားအဖွဲ့ဝင်များနှင့် မျှဝေခြင်းများကို လုံခြုံစိတ်ချစွာ ပြုလုပ်နိုင်ပါသည်။",
	"home.navigator.menu.together.noPosts.title": "အဖွဲ့အစည်းမှ ကြိုဆိုပါသည်။",
	"home.navigator.menu.trendingPosts": "ဖတ်ရှုသင့်သောဆောင်းပါးများ",
	"home.navigator.menu.trendingPosts.seeMore": "ထပ်မံ ကြည့်ရှုမည်",
	"home.navigator.menu.videos": "ဗီဒီယိုများ",
	"home.navigator.menuItem.allCategories": "ကဏ္ဍအားလုံး ကြည့်ရှုမည်။",
	"home.navigator.menuItem.allCommunities": "အဖွဲ့အားလုံးကို ကြည့်မည်။",
	"home.navigator.menuItem.allCommunitiesheadingTitle": "သင်နဲ့ သက်ဆိုင်တဲ့ အဖွဲ့အစည်းများကို ရှာဖွေမယ်။",
	"home.navigator.menuItem.allHealthTools": "ကိရိယာများကို ကြည့်မည်။",
	"home.navigator.menuItem.allSpecialties": "All specialties",
	"home.navigator.menuItem.allSpotlight": "အာရုံစိုက်ရမည့် အကြောင်းအရာများကို ကြည့်ရန်",
	"home.navigator.menuItem.allVideos": "See All Videos",
	"home.navigator.menuItem.discover": "ဆောင်းပါးများ",
	"home.navigator.menuItem.healthCategories": "ကျန်းမာရေး ကဏ္ဍများ",
	"home.navigator.menuItem.healthTools": "ကိရိယာများ",
	"home.navigator.menuItem.healthToolsList": "ကျန်းမာရေးကိရိယာများ",
	"home.navigator.menuItem.helloCare": "ဆရာဝန်ပြရန်ဘိုကင်",
	"home.navigator.menuItem.helloEcom": "ဆေးဆိုင်",
	"home.navigator.menuItem.helloTogether": "အဖွဲ့များ",
	"home.navigator.menuItem.language": "ဘာသာစကား",
	"home.navigator.menuItem.new": "new",
	"home.navigator.menuItem.specialties": "ကျမ်းကျင်နယ်ပယ်များ",
	"home.navigator.menuItem.spotlights": "အာရုံစိုက်ရမည့် အကြောင်းအရာ",
	"home.navigator.menuItem.video": "Video",
	"home.navigator.menuItem.videoCategories": "Video Categories",
	"home.search": "ရှာဖွေမည် {site}",
	"home.seeAll": "အားလုံးကို ကြည့်မည်။",
	"home.seeAllCategories": "ခေါင်းစဉ်အားလုံးကို ကြည့်မည်။",
	"home.seeExpert": "ကျွမ်းကျင်ပညာရှင်များရဲ့ ကိုယ်ရေးအချက်အလက်များကို ကြည့်မည်။",
	"home.seeHospital": "ဆေးရုံအကြောင်း အသေးစိတ်ကြည့်မည်။",
	"home.seeMore": "ပိုမိုကြည့်ရှုမည်။",
	"home.seeMoreExperts": "ကျွမ်းကျင်ပညာရှင်များကို ကြည့်မည်။",
	"hospital.content.description": "Hospital Details",
	"inputComment.replyTo": "{name}ကို ပြန်လည်ဖြေကြားမယ်။",
	insert: insert,
	"label.latestPost": "နောက်ဆုံးပို့စ်များ",
	"label.pinnedPost": "ထိပ်ဆုံးတွင်မှတ်ထားသည့်ပို့စ်",
	"lead.empty.cancel": "မလုပ်ဆောင်ပါ",
	"lead.empty.submitAgain": "ထပ်မံတင်သွင်းပါ",
	"lead.empty.title": "အုပ်စ်! သင့်အချက်အလက်သည် ဗလာဖြစ်နေသလိုဖြစ်သည်။ ထပ်မံတင်သွင်းလိုပါသလား?",
	"leadgen.message.error.name_required": "Please enter your name",
	"leadgen.message.error.phone_invalid": "Please enter a valid phone number",
	loading: loading,
	"login.booking": "ဆရာဝန်နှင့်ပြသရန် ဘိုကင်တင်မည်။",
	"logout.popup.ask.mb": "Logout of Marry Baby",
	"logout.popup.ask1": "Hello Sayarwon မှ ထွက်မည်။",
	"logout.popup.ask2": "ထွက်မှာ သေချာပြီလား။",
	"logout.popup.button.cancel": "မထွက်ပါ။",
	"logout.popup.button.logout": "ထွက်မည်။",
	"menu.care.searchBySpecialties": "Search by specialty",
	"morePopover.report": "တိုင်ကြားမည်.",
	"morePopover.report.description": "ဤပို့စ်နှင့်ပတ်သက်ပြီး မည်သည့်ပြဿနာရှိသည်ဆိုတာကို သိလိုပါသည်။ ကျေးဇူးပြုပြီး ပြောပြနိုင်မလား။",
	"morePopover.report.falseNews": "သတင်းမှား",
	"morePopover.report.offensive": "စော်ကားပြောဆို",
	"morePopover.report.other": "အခြား",
	"morePopover.report.prohibited": "တားမြစ်ထားသော အကြောင်းအရာ",
	"morePopover.report.scam": "အယူအဆမှား သို့ scam",
	"morePopover.report.sex": "လိင်ပိုင်းဆိုင်ရာ မသင့်တော်သော အကြောင်းအရာ",
	"morePopover.report.spam": "မမှန်ကန်သောအချက်အလက်များ",
	"morePopover.report.title": "ဤပို့စ်ကို တိုင်ကြားမည်။",
	"morePopover.report.violence": "အကြမ်းဖက်",
	"morePopover.reportSubmit.description": "ဤပို့စ်ကို မည်သူတိုင်ကြားသွားသည်ကို ပြောမည်မဟုတ်ပါ။ ကျေးဇူးပြု၍ အောက်ပါအချက်အလက်များကို စစ်ဆေးပါ။",
	"morePopover.reportSubmit.title": "တိုင်ကြားချက် တင်ပါမည်လား။",
	"morePopover.savePost": "ပို့စ်ကို သိမ်းဆည်းမည်။",
	"morePopover.share": "မျှဝေမည်။",
	"morePopover.shareOn": "တွင် မျှဝေမည်။",
	"morePopover.turnOffNotifications": "အသိပေးချက်များကို ပိတ်မည်။",
	"morePopover.turnOnNotifications": "အသိပေးချက်များကို လက်ခံမည်။",
	"morePopover.unsavePost": "သိမ်းဆည်းထားသော ပို့စ်ကို ဖယ်ရှားမည်။",
	"navigation.loginJoin": "ဝင်မည်",
	"navigation.search.input.placeholder": "ရှာဖွေမည်",
	"navigation.signUp": "Sign up",
	"newsletter.error.minCotennt": "Please select at least 1 topic to continue this action",
	"newsletter.error.minTitle": "Minimum 1 topics reached",
	"newsletter.topic.title": "What health topics are you interested in?",
	"newsletter.welcome.description": "What name would you prefer to go by?",
	"notification.comment.blocked.message": "မှတ်ချက်တွင် တားမြစ်ထားသည့် စာလုံးများ ပါဝင်နေသည့်အတွက် မှတ်ချက်ပေး၍မရနိုင်ပါ။",
	"notification.comment.blocked.title": "မှတ်ချက်ကို ပိတ်ပင်မည်။",
	"notification.comment.premod": "သင့်မှတ်ချက်ကို စစ်ဆေးရန်လိုအပ်ပါသည်။",
	"notification.comment.rejected": "သင့်မှတ်ချက်တွင် မသင့်တော်သော စကားလုံးများပါဝင်ပါသည်။",
	"notification.comment.reportFailed": "ပြုလုပ်၍မရပါ။",
	"notification.comment.reportSuccess": "မှတ်ချက်အား အောင်မြင်စွာ တိုင်ကြားပြီးပါပြီ။",
	"notification.comment.somethingWrong": "တစ်ခုခုမှားနေပါသည်။",
	"notification.comment.suspect.message": "မှတ်ချက်တွင် သံသယဖြစ်ဖွယ် စာလုံးများ ပါဝင်နေသည့်အတွက် မှတ်ချက်ပေး၍မရနိုင်ပါ။",
	"notification.comment.suspect.title": "မှတ်ချက်အား စစ်ဆေးနေသည်။",
	"notification.comment.systemWithheld": "သင့်မှတ်ချက်ကို စစ်ဆေးရန်လိုအပ်ပါသည်။",
	"notification.failure": "တစ်ခုခုမှားနေပါသည်။ ခဏနေမှထပ်ကြိုးစားကြည့်ပါ။",
	"notification.limitUrlDomain": "Hello Health Group ပြင်ပမှ လင့်များကို ပို့စ်တင်၍မရနိုင်ပါ။",
	"notification.post.blocked.message": "ပို့စ်တွင် တားမြစ်ထားသည့် စာလုံးများ ပါဝင်နေသည့်အတွက် ပို့စ်တင်၍မရနိုင်ပါ။",
	"notification.post.blocked.title": "ပို့စ်ကို ပိတ်ပင်မည်။",
	"notification.post.delete": "ဖျက်လိုက်သည့်ပို့စ်",
	"notification.post.suspect.message": "ပို့စ်တွင် သံသယဖြစ်ဖွယ် စာလုံးများ ပါဝင်နေသည့်အတွက် မော်ဒရေတာမှ စစ်ဆေးနေပါသည်။",
	"notification.post.suspect.title": "ပို့စ်အား စစ်ဆေးနေသည်။",
	"notification.success": "အောင်မြင်ပါတယ်။",
	"notification.suspend.message": "ကျွန်ုပ်တို့ရဲ့ စည်းမျဉ်းစည်းကမ်းများကို ချိုးဖောက်သည့်အတွက် သင့်အကောင့်ကို ထိန်းချုပ်ထားပါတယ်။",
	"notification.urlWrongFormat": "URL format မှားနေပါတယ်။",
	"onboarding.button.continue": "ဆက်မည်။",
	"onboarding.button.skip": "ကျော်မည်။",
	"onboarding.errorMessage.invalidEmail": "အသုံးပြု၍မရသော အီးမေးလ်",
	"onboarding.errorMessage.minLength": "စာလုံး {length}လုံးနဲ့အထက်ပါအောင် ဖြည့်ပေးပါ။",
	"onboarding.errorMessage.passNotMatch": "စကားဝှက်မကိုက်ညီပါ။",
	"onboarding.errorMessage.passWithPattern": "စကားဝှက်တွင် စာလုံးအကြီးရော အသေးပါ ပါရပါမည်။",
	"onboarding.errorMessage.requiredConfirmPassword": "စကားဝှက်ကို အတည်ပြုပါ။",
	"onboarding.errorMessage.requiredEmail": "သင့်အီးမေးလ်ကို ဖြည့်ပါ။",
	"onboarding.errorMessage.requiredName": "သင့်အမည်ကို ဖြည့်ပါ။",
	"onboarding.errorMessage.requiredPassword": "စကားဝှက်ကို ဖြည့်ပါ။",
	"onboarding.formEmail.description": "Hello ဆရာဝန် အဖွဲ့အစည်းများတွင်ပါဝင်ရန် အီးမေးလ်ဖြင့် ဝင်မည်။",
	"onboarding.formEmail.genderFemale": "အမျိုးသမီး",
	"onboarding.formEmail.genderMale": "အမျိုးသား",
	"onboarding.formEmail.heading": "သင့်အကြောင်းပိုမိုသိရှိလိုပါသည်။",
	"onboarding.formEmail.yourBirthday": "သင့်မွေးနေ့",
	"onboarding.formEmail.yourEmail": "သင့်အီးမေးလ်",
	"onboarding.formEmail.yourName": "သင့်အမည်",
	"onboarding.label.fullName": "Full name",
	"onboarding.otpForm.description": "တစ်ခါသုံးစကားဝှက် One-Time Password (OTP)ကို သင့်ဖုန်းနံပါတ် {phone}သို့ ပို့လိုက်ပါပြီ။",
	"onboarding.otpForm.descriptionEmail": "သင့်အီးမေးလ် {email}ကို တစ်ခါသုံး စကားဝှက် One-Time Password (OTP) ပို့ပြီးပါပြီ။  ",
	"onboarding.otpForm.error": "အသုံးပြု၍ရသော ဖုန်းနံပါတ်ကို ဖြည့်ပေးပါ။",
	"onboarding.otpForm.heading": "OTPကို ဖြည့်ပါ။",
	"onboarding.otpForm.notReceiveOTP": "OTPကုဒ် မရဘူးလား။",
	"onboarding.otpForm.resendCode": "ကုဒ်ပြန်ပို့ပါ",
	"onboarding.otpForm.resendCodeWithSeconds": "ကုဒ်ကို  {seconds}စက္ကန့်အတွင်း ပြန်ပို့ပေးပါမည်။",
	"onboarding.otpWhatsapps.description": "ကျွန်တော်တို့သည်သင့် WhatsApp နံပါတ် {phone} သို့မဟုတ် One-Time Password (OTP) ကို ပို့နေသည်။",
	"onboarding.otpWhatsapps.heading": "WhatsApp အတည်ပြု",
	"onboarding.similac.address.error": "Your address is required",
	"onboarding.similac.input.address": "Your address",
	"onboarding.similac.input.city": "Please select your city/province",
	"onboarding.similac.input.district": "Please select your district/town",
	"onboarding.similac.input.no": "Please enter your street name, building, house no.",
	"onboarding.similac.input.phone": "Your phone number",
	"onboarding.similac.input.ward": "Please select your ward/village",
	"onboarding.updatePassword.confirmPassword": "စကားဝှက်ကို အတည်ပြုပါ။",
	"onboarding.updatePassword.description": "စာလုံး ၈လုံးနဲ့အထက်ပါအောင် ဖြည့်ပေးပါ။",
	"onboarding.updatePassword.heading": "ပြီးတော့မှာပါ။ စကားဝှက်ပဲ လိုပါတော့တယ်။",
	"onboarding.updatePassword.password": "စကားဝှက်",
	"onboarding.updatePasswordResult.description": "အခုဆိုရင် သင့်ရဲ့ Hello ဆရာဝန်အကောင့်ကို စကားဝှက်အသစ်နဲ့ ဝင်နိုင်ပါပြီ။",
	"onboarding.updatePasswordResult.heading": "စကားဝှက်ထည့်တာ အောင်မြင်သွားပါပြီ။ ",
	"onboarding.updatePhone.description": "တစ်ခါသုံးစကားဝှက် One-Time Password (OTP)ကို သင့်ဖုန်းနံပါတ်သို့ ပို့ပေးပါမည်။",
	"onboarding.updatePhone.error": "အသုံးပြု၍ရသော ဖုန်းနံပါတ်ကို ဖြည့်ပေးပါ။",
	"onboarding.updatePhone.heading": "သင့်ဖုန်းနံပါတ်",
	"onboarding.updateWhatsapp.description": "Whatsapp သည်သင့်ဖုန်းနံပါတ်ကို အတည်ပြုရမည်။",
	"onboarding.updateWhatsapp.submitLabel": "WhatsApp နှင့် ဆက်သွယ်ပါ",
	"onboarding.welcomeScreen.content": "ပိုမိုကျန်းမာပျော်ရွှင်စေဖို့ တခြားအဖွဲ့ဝင်များနဲ့ ကျန်းမာရေးအချက်အလက်တွေ မျှဝေနိုင်တဲ့ နွေးထွေးတဲ့ နေရာလေးပဲ ဖြစ်ပါတယ်။",
	"onboarding.welcomeScreen.heading": "Hello ဆရာဝန် အဖွဲ့အစည်းမှ ကြိုဆိုပါတယ်။ ",
	orCopyLink: orCopyLink,
	"ovulationPage.avoidPregnancy": "ကိုယ်ဝန် မယူလိုပါ။",
	"ovulationPage.conceive": "ကိုယ်ဝန်ယူရန် ကြိုးစားနေသည်။",
	"ovulationPage.cycleLength": "ရာသီစက်ဝန်း ရက်အရေအတွက်",
	"ovulationPage.dayUnit": "(days) ရက်",
	"ovulationPage.objectives": "ရည်ရွယ်ချက်",
	"ovulationPage.periodDuration": "ရာသီရက်စုစုပေါင်း",
	"ovulationPage.trackPeriod": "ရာသီစက်ဝန်းကို တွက်ချက်ပါ။",
	"placeholder.enterTitleHere": "ဒီနေရာမှာ ခေါင်းစဉ်ကို ဖြည့်ပါ။",
	"placeholder.enterUrlHere": "ဒီနေရာမှာ URLကို ဖြည့်ပါ။",
	"placeholder.enterUrlTextHere": "ဒီနေရာမှာ URL Textကို ဖြည့်ပါ။",
	"placeholder.newCmt": "မှတ်ချက်ရေးပါ။",
	"placeholder.newPost": "ပို့စ်အသစ်ကို စတင်မည်။",
	"pnBanner.both": "Both",
	"pnBanner.both.desc": "Welcome to the adventure of parenthood! Choose a tool that suit you.",
	"pnBanner.both.heading": "Experience our tools for parent!",
	"pnBanner.caclNow": "Calculate now",
	"pnBanner.checkNow": "Check now!",
	"pnBanner.dueDateTool.desc": "Plan ahead for the big day with a stress-free experience!",
	"pnBanner.dueDateTool.heading": "Try our Due Date Calculator",
	"pnBanner.hpv.desc": "Your response helps us craft recommendations specific to your family's needs.",
	"pnBanner.hpv.heading": "Keep your girl safe from HPV virus!",
	"pnBanner.parenting.desc": "Your response helps us craft recommendations specific to your family's needs. ",
	"pnBanner.parenting.heading": "What is the age range of your kids?",
	"pnBanner.pn.btnLabel": "Premium Newsletter",
	"pnBanner.pregnancy.desc": "Input this to ensure our recommendations suits your exciting new journey.",
	"pnBanner.pregnancy.heading": "Are you navigating the world of pregnancy?",
	"pnBanner.submit": "Submit",
	"pnBanner.teenager": "Teenager",
	"pnBanner.teenager.heading": "What is the gender of your kids?",
	"pnBanner.toddlers": "Toddlers",
	"pnBanner.vaccination.desc": "Keep your little one protected with customized vaccination schedules!",
	"pnBanner.vaccination.heading": "Try our Baby Vaccine Scheduler",
	"pnBanner.vaccine.btnLabel": "Baby Vaccine Scheduler",
	"pnModal.disclaimer": "Your first email digest is on its way. Get excited to dive into content that’s tailored specifically for you!",
	"pnTopicSection.maxSelectError.desc": "Remove at least 1 selected topic to continue this action",
	"pnTopicSection.maxSelectError.detail": "Choose maximum {max} topics ({maxTopic})",
	"pnTopicSection.maxSelectError.title": "Maximum {maxSelect} topics reached",
	"pnTopicSection.notFound": "Nothing found",
	"pnTopicSection.plsEnterFavTopics": "Please enter your favorite topics",
	"pnTopicSection.ppAlsoInterested": "People are also interested",
	"pnTopicSection.recentView": "Recently viewed",
	"pnTopicSection.trending": "Trending",
	"popup.allTopics": "ခေါင်းစဉ်အားလုံး",
	"popup.createPost.confirmCloseDescription": "ယခုဖျက်လိုက်လျှင် သင်ပို့စ်ပျက်စီးသွားပါမည်။",
	"popup.createPost.confirmCloseTitle": "သေချာပါပြီလား။",
	"popup.deleteComment.description": "မှတ်ချက်ကို ဖျက်ပြီးပါက ပြန်ပြင်၍မရနိုင်ပါ။",
	"popup.deleteComment.title": "မှတ်ချက်ကို ဖျက်မည်လား။",
	"popup.deletePost.accept": "ဖျက်မယ်။",
	"popup.deletePost.cancel": "မဖျက်ပါ။",
	"popup.deletePost.description": "ပို့စ်ကို ဖျက်ပြီးပါက ပြန်ပြင်၍မရနိုင်ပါ။",
	"popup.deletePost.title": "ပို့စ်ဖျက်မည်လား။",
	"popup.discardPost": "ပို့စ်ကို ဖျက်မည်။",
	"popup.discardPostEdit": "ပြုပြင်ထားသည်များကို ဖျက်မယ်။",
	"popup.editPost": "ပို့စ်ကို ပြုပြင်မည်။",
	"popup.keepEditing": "ဆက်လက်ပြင်ဆင်မည်။",
	"popup.startANewPost": "ပို့စ်အသစ်ကို စတင်မည်။",
	"post.commentCount": "မှတ်ချက် {count} ခု",
	"post.likesCount": "နှစ်သက်မှု {count} ခု",
	"post.remove.failed": "ဖယ်ရှားမှု မအောင်မြင်ပါ",
	"post.remove.success": "သိမ်းဆည်းထားသောပို့စ်ကို ဖယ်ရှားပြီးပြီ",
	"post.save.failed": "ပို့စ် သိမ်းဆည်းမှု မအောင်မြင်ပါ",
	"post.save.success": "ပို့စ်ကို သိမ်းဆည်းပြီးပြီ",
	"post.seeMore": "ပိုမိုကြည့်ရှုရန်",
	"post.shareCount": "မျှဝေမှု {count} ခု",
	"pregnancy.week": "ရက်သတ္တပတ်",
	"pregnancyTool.description": "သင့်ကလေးက <fruitName></fruitName> အရွယ်လောက် ရှိပါပြီ။",
	"pregnancyTool.title": "ကိုယ်ဝန်ပတ်",
	"pregnancyTool.weightSuggested": "ရှိသင့်သည့် ကိုယ်အလေးချိန်",
	"pregnancyWeightGain.havingTwins": "အမြွာကိုယ်ဝန်ရှိနေပါသလား။",
	"pregnancyWeightGain.heading": "ကိုယ်ဝန်ဆောင်ချိန် ကိုယ်အလေးချိန်တွက်ချက်ခြင်း",
	"pregnancyWeightGain.heightInput": "သင့်အရပ်",
	"pregnancyWeightGain.weekInput": "ကိုယ်ဝန် ဘယ်နှပတ် ရှိပြီလဲ။",
	"pregnancyWeightGain.weightBeforeInput": "ကိုယ်ဝန်မဆောင်ခင်က ကိုယ်အလေးချိန် ဘယ်လောက် ရှိသလဲ။",
	"pregnancyWeightGain.weightInput": "လက်ရှိ ကိုယ်အလေးချိန် ဘယ်လောက်လဲ။",
	"pregnancyWeightGain.weightInput.desc": " (ကီလိုဂရမ်)",
	"pregnancyWeightGain.weightInput.error": "သင့်တော်သည့် ကိုယ်အလေးချိန်ကို ဖြည့်ပါ။",
	"previewPhotos.title": "{name}၏ ပို့စ်",
	"profilePanel.anserwing.viewFull": "အဖြေအပြည့်အစုံကို ကြည့်မည်",
	"profilePanel.awards": "အသိအမှတ်ပြုလက်မှတ်များ",
	"profilePanel.createPost": "ပို့စ်ဖန်တီးမည်",
	"profilePanel.education": "ပညာအရည်အချင်း",
	"profilePanel.emptyCareMess.content": "ယခုနှစ်တာကြားမှာ ဆရာဝန်များအတွက် မေးခွန်းများမရှိပါ။ ကျွန်တော့်အားလုံးပေါ်မှာ သင့်တော်တော်များကို ပို့ပေးနိုင်ပါတယ်။",
	"profilePanel.emptyPostMess.content": "{name} သည် မည်သည့်လှုပ်ရှားမှုတွင်မှ ပါဝင်ခြင်း မရှိပါ။",
	"profilePanel.experience": "အတွေ့အကြုံများ",
	"profilePanel.joined": "ပါဝင်ပြီး",
	"profilePanel.modal.heading": "ကိုယ်ရေးအကျဉ်း",
	"profilePanel.publishcation": "စာတမ်းများ",
	"profilePanel.publishedArticles": "Hello ဆရာဝန်မှ ထုတ်ဝေထားသော ဆောင်းပါးများ",
	"profilePanel.question": "မေးခွန်း",
	"profilePanel.questionNotClear": "မေးခွန်းမှာ ရှင်းလင်းမှု မရှိပါ။",
	"profilePanel.skipQuestion.content": "ဤမေးခွန်းကို သင့်စာရင်းမှ ဖယ်ထုတ်မည်။",
	"profilePanel.skipQuestion.heading": "ဤမေးခွန်းကို ကျော်မည်။",
	"profilePanel.socialLinks": "ဆိုရှယ်မီဒီယာ",
	"profilePanel.tabs.care": "ဆရာဝန်အတွက် မေးခွန်းများ",
	"profilePanel.tabs.expertAnswer": "ဆရာဝန်မှ ဖြေဆိုထားသော",
	"profilePanel.tabs.highlight": "အထောက်အထားများ",
	"profilePanel.tabs.posts": "ပို့စ်များ",
	"profilePanel.tabs.relevantArticles": "သင့်တော်သော ဆောင်းပါးများ",
	"pwg.placeholder.height": "သင့်အရပ် အမြင့် (cm)",
	"pwg.placeholder.weight": "သင့်ကိုယ်အလေးချိန် (kg)",
	"pwgForm.week": "အပါတ်",
	"sensitiveMask.blur": "ဝါးမည်။",
	"sensitiveMask.contentWarningDescription": "သတိပေးချက် : ဤပုံသည် စိတ်အနှောင့်အယှက်ဖြစ်စေနိုင်ပါသည်။ ကြည့်ရှုသူများအား သတိထားကြည့်စေလိုပါသည်။",
	"sensitiveMask.contentWarningDescription.community": "အကြောင်းကြားချက် - ပုံရိပ်သည် အဆိပ်အတောက်ဖြစ်စေနိုင်သည်။",
	"sensitiveMask.contentWarningMessage": "ဤပုံသည် စိတ်အနှောင့်အယှက်ဖြစ်နိုင်ပါသည်။",
	"sensitiveMask.unblur": "ပြပါ။",
	"share.by": "ကူးယူပြီးမျှဝေပါ",
	"share.copyLink": "သို့မဟုတ် လင့်ကို ကူးယူမည်။",
	"share.letsJoinCommunity": "{name} အဖွဲ့အစည်းတွေ ပါဝင်ရအောင်။",
	"share.letsJoinTopic": "{name} ခေါင်းစဉ်များကို လေ့လာရန် ပါဝင်လိုက်ပါ။",
	"share.linkCopied": "လင့်ကို ကူးယူပြီး",
	"share.linkShared": "လင့်ကို အောင်မြင်စွာ မျှဝေပြီး",
	"share.title": "မျှဝေမည်။",
	"shareContainer.title": "ရလဒ်များကို မျှဝေမည်။",
	"similac.thankYou.done": "Done",
	"ssov2.abTestingFlowB.description": "Sign up or log in with your email or social media account.",
	"ssov2.button.cancel": "Cancel",
	"ssov2.button.continue": "Continue",
	"ssov2.button.continueGoogle": "Continue with Google",
	"ssov2.button.continueSMS": "Continue with SMS",
	"ssov2.button.continueWhatsApp": "Continue with WhatsApp",
	"ssov2.button.continueZalo": "Continue with Zalo",
	"ssov2.button.exitNow": "I want to exit now",
	"ssov2.button.otp.sms": "Send OTP Code via SMS",
	"ssov2.button.otp.whatsapp": "Send OTP Code via WhatsApp",
	"ssov2.button.otp.zalo": "Send OTP Code via Zalo",
	"ssov2.button.save": "Save",
	"ssov2.button.setupLater": "Setup later",
	"ssov2.collectInfo.why": "Why We Need Your Information?",
	"ssov2.email.alreadyUsed": "Email này đã được sử dụng, vui lòng chọn Email khác.",
	"ssov2.email.button": "Verify Your Email",
	"ssov2.email.description": "Use your email to continue login or register",
	"ssov2.email.title": "Continue with email",
	"ssov2.error.api": "API error",
	"ssov2.error.api.000": "Some Things Went Wrong",
	"ssov2.error.api.001": "The email must be a valid email address.",
	"ssov2.error.api.002": "The email field is required.",
	"ssov2.error.api.003": "This member is not exist yet",
	"ssov2.error.api.004": "The email may not be greater than 255 characters.",
	"ssov2.error.api.005": "The phone number field is required.",
	"ssov2.error.api.006": "The phone number must be at least 9 characters.",
	"ssov2.error.api.007": "This phone number is already linked to your profile",
	"ssov2.error.api.008": "The otp code field is required.",
	"ssov2.error.api.009": "User don't update",
	"ssov2.error.api.010": "Verify OTP failed",
	"ssov2.error.api.011": "The name must be a string.",
	"ssov2.error.api.012": "The name may not be greater than 100 characters.",
	"ssov2.error.api.013": "The username must be a string.",
	"ssov2.error.api.014": "The username has already been taken.",
	"ssov2.error.api.015": "The username may not be greater than 20 characters.",
	"ssov2.error.api.016": "The birthday does not match the format Y-m-d.",
	"ssov2.error.api.017": "The avatar field is required.",
	"ssov2.error.api.018": "The avatar must be an image.",
	"ssov2.error.api.019": "The avatar must be a file of type: jpeg, jpg, png, gif.",
	"ssov2.error.api.020": "The avatar may not be greater than 10240 kilobytes.",
	"ssov2.error.api.021": "The confirm-password field is required.",
	"ssov2.error.api.022": "The confirm-password must be at least 8 characters.",
	"ssov2.error.api.023": "The confirm-password format is invalid.",
	"ssov2.error.api.024": "The confirm-password may not be greater than 50 characters.",
	"ssov2.error.api.025": "The new-password field is required.",
	"ssov2.error.api.026": "The new-password must be at least 8 characters.",
	"ssov2.error.api.027": "The new-password format is invalid.",
	"ssov2.error.api.028": "The new-password may not be greater than 50 characters.",
	"ssov2.error.api.029": "Your password doesn't match. Please try again.",
	"ssov2.error.api.030": "Your new password must be different from the current one",
	"ssov2.error.api.031": "The new password field is required.",
	"ssov2.error.api.032": "The confirm new password field is required.",
	"ssov2.error.api.033": "The new password and confirm new password must match.",
	"ssov2.error.api.034": "The confirm new password must be at least 8 characters.",
	"ssov2.error.api.035": "The new password must be at least 8 characters.",
	"ssov2.error.api.036": "The confirm new password may not be greater than 50 characters.",
	"ssov2.error.api.037": "The new password may not be greater than 50 characters.",
	"ssov2.error.api.038": "The current password is wrong!",
	"ssov2.error.api.039": "The password field is required.",
	"ssov2.error.api.040": "Token Signature could not be verified.",
	"ssov2.error.api.041": "Token has expired",
	"ssov2.error.api.042": "The refresh token field is required.",
	"ssov2.error.api.043": "The area code field is required.",
	"ssov2.error.api.044": "The email has already been taken.",
	"ssov2.error.api.045": "Verify Email OTP Code Fail",
	"ssov2.error.api.046": "The code field is required.",
	"ssov2.error.api.047": "The phone number has already been taken.",
	"ssov2.error.api.048": "The Phone is not match phone number that you registered",
	"ssov2.error.api.049": "User was exist",
	"ssov2.error.api.050": "The website id field is required.",
	"ssov2.error.api.051": "The name field is required.",
	"ssov2.error.api.052": "The birthday field is required.",
	"ssov2.error.api.053": "The gender field is required.",
	"ssov2.error.api.054": "The provider field is required.",
	"ssov2.error.api.055": "The token field is required.",
	"ssov2.error.api.056": "Code has been sent to your email",
	"ssov2.error.api.057": "The email does not exist.",
	"ssov2.error.api.058": "You are verifying a phone number that is not yours",
	"ssov2.error.api.059": "The selected phone number is invalid.",
	"ssov2.error.api.060": "Phone does not member",
	"ssov2.error.api.061": "This phone number is already linked to your profile",
	"ssov2.error.api.062": "Error ZNS with missing msg_id",
	"ssov2.error.api.063": "OTP verify missing",
	"ssov2.error.api.064": "The expire at must be a date after 5 mins.",
	"ssov2.error.api.065": "The selected code is invalid.",
	"ssov2.error.api.066": "Error when update ZNS tracking",
	"ssov2.error.api.067": "Sent Zalo OTP failed",
	"ssov2.error.api.068": "The expire at must be a date after 10 mins.",
	"ssov2.error.api.069": "The code must be at least 6 characters.",
	"ssov2.error.api.070": "The code may not be greater than 10 characters.",
	"ssov2.error.api.071": "You’ve reached the limit of 3 verification attempts in 1 hour. Please wait and try again later.",
	"ssov2.error.api.072": "You’ve reached the limit of 5 verification attempts today. Please try again tomorrow.",
	"ssov2.error.api.073": "The password must be at least 8 characters.",
	"ssov2.error.api.074": "The password format is invalid.",
	"ssov2.error.api.075": "The confirm-password format is invalid.",
	"ssov2.error.api.076": "The password must contain at least one number.",
	"ssov2.error.api.077": "The confirm-password must contain at least one number.",
	"ssov2.error.api.078": "The email was exist",
	"ssov2.error.api.079": "Too many messages",
	"ssov2.error.api.080": "The selected otp code is invalid",
	"ssov2.error.api.082": "The password must contain at least one uppercase and one lowercase letter.",
	"ssov2.error.api.083": "Sent Whatsapp OTP failed",
	"ssov2.error.facebookLogin": "Facebook login failed",
	"ssov2.error.googleLogin": "Error login with Google",
	"ssov2.first.country.code": "Country Code",
	"ssov2.first.description": "Continue with your phone number, email or your socials to log in or sign up.",
	"ssov2.first.noAccountOrPass": "You have no account or need to setup password, please continue register",
	"ssov2.first.search.country.all": "All Countries",
	"ssov2.first.search.country.placeholder": "Search country/region",
	"ssov2.first.search.country.selected": "Current selection",
	"ssov2.first.title.login": "Log In",
	"ssov2.first.title.signup": "Sign Up",
	"ssov2.orContinueWith": "Or continue with",
	"ssov2.otp.email.description": "Enter the 6-digit OTP sent to your email <b>{email}</b>. OTP code will expire in <b>10 mins</b>",
	"ssov2.otp.email.title": "Verify Email",
	"ssov2.otp.phone.description": "Enter the 6-digit OTP sent to the phone number <b>{phone}</b> via <b>{method}</b>. OTP code will expire in <b>10 mins</b>",
	"ssov2.otp.phone.title": "Verify Phone Number",
	"ssov2.otp.resendQuestion": "Didn’t receive the code?",
	"ssov2.otp.resendText": "Resend ({count}s)",
	"ssov2.otp.sendVia": "Send OTP Code via {method}",
	"ssov2.password.description": "Đăng nhập bằng mật khẩu của bạn.",
	"ssov2.password.forgotPassword": "Forgot Password?",
	"ssov2.password.reset": "Reset",
	"ssov2.password.signIn": "Sign In",
	"ssov2.password.title1": "Welcome back!",
	"ssov2.password.title2": "Enter your password",
	"ssov2.passwordForgotSetup.description": "Set up your login password and other details to complete the registration process.",
	"ssov2.passwordForgotSetup.field.password.atLeast8Chars": "At least 8 characters.",
	"ssov2.passwordForgotSetup.field.password.atLeastOneUpper": "At least one uppercase letter, one lowercase letter, and one number.",
	"ssov2.passwordForgotSetup.field.password.label": "Password",
	"ssov2.passwordForgotSetup.field.password.placeholder": "Input your password",
	"ssov2.passwordForgotSetup.field.passwordConfirm.label": "Confirm Password",
	"ssov2.passwordForgotSetup.field.passwordConfirm.placeholder": "Confirm Password",
	"ssov2.passwordForgotSetup.title": "Setup your password",
	"ssov2.phone.alreadyUsed": "Phone number is already used, please use another phone number",
	"ssov2.phoneVerify.description": "Please provide additional information to complete the account registration process.",
	"ssov2.phoneVerify.title": "Verify Phone Number",
	"ssov2.policyText": "By signing up, I confirm that I have read, understand and agree to the {privacy} and the {terms} of Hello Health Group. I agree for Hello Health Group to collect, store, use, disclose, and process my information in accordance with Hello Health Group’s Privacy Policy. Furthermore, I agree for Hello Health Group to use my information to send me promotional information (including by direct mail, email, telephone, and text message) or otherwise contact me about products, services, programs or other topics that Hello Health Group think may interest me; and Hello Health Group can share my information to its partners and clients in order for them to provide more helpful services and promotional information.",
	"ssov2.policyText.community": "By signing up, I confirm that I have read, understand and agree to the {privacy} and the {terms} of Hello Health Group. I agree to join the community of HelloDoctor, and I agree for Hello Health Group to collect, store, use, disclose, and process my information in accordance with Hello Health Group’s Privacy Policy. Furthermore, I agree for Hello Health Group to use my information to send me promotional information (including by direct mail, email, telephone, and text message) or otherwise contact me about products, services, programs or other topics that Hello Health Group think may interest me; and Hello Health Group can share my information to its partners and clients in order for them to provide more helpful services and promotional information.",
	"ssov2.policyText.privacy": "Privacy Policy",
	"ssov2.policyText.terms": "Terms of Service",
	"ssov2.popup.close.description": "You’re just a step away from completing your account setup. Do you really want to leave?",
	"ssov2.popup.close.title": "Are you sure you want to exit?",
	"ssov2.resetPassword.description": "Please provide the phone number you used to create your account.",
	"ssov2.resetPassword.title": "Reset password",
	"ssov2.setup.button.createAccount": "Create new account",
	"ssov2.setup.button.veriyPhone": "Verify Phone Number",
	"ssov2.setup.description": "Please provide additional information to complete the account registration process.",
	"ssov2.setup.field.dob.label": "Birthday",
	"ssov2.setup.field.dob.placeholder": "Enter your birthday",
	"ssov2.setup.field.email.label": "Email",
	"ssov2.setup.field.gender.female": "Female",
	"ssov2.setup.field.gender.label": "Gender",
	"ssov2.setup.field.gender.male": "Male",
	"ssov2.setup.field.name.label": "Name",
	"ssov2.setup.field.name.placeholder": "Enter your name",
	"ssov2.setup.field.otp.label": "Receive OTP Via",
	"ssov2.setup.field.phone.label": "Phone number",
	"ssov2.setup.title": "Almost done!",
	"ssov2.updateEmail.button": "Verify Your Email",
	"ssov2.updateEmail.description": "Please update and verify your email to continue using our services.",
	"ssov2.updateEmail.title": "Update Your Email",
	"ssov2.useOtherMethod.email": "This account has not enabled login with an email. Please choose another login method.",
	"ssov2.useOtherMethod.phone": "This account has not enabled login with a phone number. Please choose another login method.",
	"ssov2.validate.confirmPassword.match": "Passwords must match",
	"ssov2.validate.confirmPassword.required": "Confirm password is required",
	"ssov2.validate.dob.required": "Date of birth is required",
	"ssov2.validate.email.invalid": "Invalid email",
	"ssov2.validate.email.required": "Email is required",
	"ssov2.validate.gender.oneOf": "Gender must be male or female",
	"ssov2.validate.gender.required": "Gender is required",
	"ssov2.validate.name.required": "Name is required",
	"ssov2.validate.otp.required": "OTP method is required",
	"ssov2.validate.password.required": "Password is required",
	"ssov2.validate.phone.required": "Phone number is required",
	submit: submit,
	"switchBtn.no": "မဟုတ်ပါ။",
	"switchBtn.yes": "ဟုတ်ပါသည်။",
	"tab.about": "အကြောင်းအရာ",
	"tab.discussion": "ဆွေးနွေးချက်များ",
	"tab.topic": "ခေါင်းစဉ်များ",
	"tagTopic.moreTopics": "နောက်ထပ်အကြောင်းအရာ {number} ခု",
	"targetHearRate.heading": "ရှိသင့်သည့် နှလုံးခုန်နှုန်း တွက်ချက်ကိရိယာ",
	"targetHeartRate.aerobicZone.note": "အေရိုးဗစ် (တစ်ပတ်လျှင် ၃-၅ရက်ခန့် လေ့ကျင့်ခန်းလုပ်)",
	"targetHeartRate.aerobicZone.title": "အေရိုးဗစ်",
	"targetHeartRate.ageInput": "မွေးနေ့",
	"targetHeartRate.ageInput.desc": " (နှစ်)",
	"targetHeartRate.ageInput.error": "သင့်လက်ရှိ အသက်ကို ဖြည့်သွင်းပါ။",
	"targetHeartRate.heartRateInput": "နားနေချိန်မှာ ရှိသည့် နှလုံးခုန်နှုန်း",
	"targetHeartRate.heartRateInput.desc": "(တစ်မိနစ်လျှင် အကြိမ်ရေ)",
	"targetHeartRate.heartRateInput.error": "သင်နားနေချိန်တွင် ရှိသည့် နှလုံးခုန်နှုန်းကို ဖြည့်သွင်းပါ။",
	"targetHeartRate.lowIntensity.note": "မပြင်းထန် (လေ့ကျင့်ခန်း မလုပ် သို့မဟုတ် မလုပ်သလောက်)",
	"targetHeartRate.lowIntensity.title": "မပြင်းထန်",
	"targetHeartRate.maximumIntensity.note": "အလွန်ပြင်းထန် (အလွန်ပြင်းထန်သော လေ့ကျင့်ခန်းများ)",
	"targetHeartRate.maximumIntensity.title": "အလွန်ပြင်းထန်",
	"targetHeartRate.moderateIntensity.note": "အသင့်အတင့် ပြင်းထန် (တစ်ပတ်လျှင် ၁-၃ရက်ခန့် လေ့ကျင့်ခန်းလုပ်)",
	"targetHeartRate.moderateIntensity.title": "အသင့်အတင့် ပြင်းထန်",
	"targetHeartRate.optional": "(မဖြစ်မနေမဟုတ်)",
	"targetHeartRate.selectActive": "နေ့စဉ် လှုပ်ရှားမှု ဘယ်လောက်ရှိပါသလဲ။",
	"targetHeartRate.vigorousIntensity.note": "ပြင်းထန် (တစ်ပတ်လျှင် ၆-၇ရက်ခန့် လေ့ကျင့်ခန်း လုပ်)",
	"targetHeartRate.vigorousIntensity.title": "ပြင်းထန်",
	"tool.askChecking": "တခြားကိရိယာများကို အသုံးပြုမည်။",
	"tool.selectPerson": "မည်သူ့အတွက် စစ်ဆေးမည်နည်း။",
	"tool.selectPerson.other": "အခြားတစ်ယောက်",
	"tool.selectPerson.yourSelf": "ကိုယ်တိုင်",
	"toolPage.toolReviewer": "ဆေးပညာပိုင်းဆိုင်ရာ တည်းဖြတ်သူ {expert_name} on {date}",
	"tools.checkYourKidsInput.label": "သင့်ကလေးအတွက် စစ်ဆေးလိုပါသလား",
	"tools.checkYrs": "သင့်အတွက် သင့်ကိုစစ်ဆေးနေပါသလား။",
	"tools.heading.on": "အပေါ်",
	"tools.heartRateRangeErr": "ကျေးဇူးပြု၍ {min} - {max} bpm အတွင်းတန်ဖိုးကို ထည့်ပါ",
	"tools.inputPlaceholder": "ဥပမာ: {content} ",
	"tools.requiredErrorMess.age": "လက်ရှိအသက်ကို ဖြည့်သွင်းပါ",
	"tools.requiredErrorMess.gender": "ကျေးဇူးပြု၍ လိင်အမျိုးအစားကို ထည့်ပါ",
	"tools.selectBabyGender": "ကလေးက ယောက်ျားလေးလား၊ မိန်းကလေးလား",
	"tools.selectGender": "ကျား / မ",
	"tools.yearsOld": "နှစ်",
	"updatePost.popup.success": "ပို့စ်ကို အောင်မြင်စွာ အပ်ဒိတ် ပြုလုပ်ပြီးပါပြီ။",
	"userProfile.nav.card.eCom": "eShop",
	"userProfile.nav.card.ecom.DeliveryAddress": "Manage addresses",
	"userProfile.nav.card.ecom.manageOrders": "Manage orders",
	"userProfile.nav.card.ecom.voucher": "Voucher",
	"userProfile.nav.card.myBooking": "ကျွန်ုပ်၏ ဘိုကင်",
	"userProfile.nav.card.myCommunity": "ကျွန်ုပ်၏ အဖွဲ့အစည်း",
	"userProfile.nav.card.myFamily": "မိသားစု ကိုယ်ရေးအချက်အလက်",
	"userProfile.nav.card.myHealth": "ကျွန်ုပ်၏ ကျန်းမာရေး",
	"userProfile.nav.card.mySaved": "သိမ်းဆည်းပြီး",
	"userProfile.nav.header.count.comments": "မှတ်ချက်များ",
	"userProfile.nav.header.count.posts": "ပို့စ်များ",
	"userProfile.nav.header.count.tools": "ကိရိယာများ",
	"userProfile.nav.header.points": "ပွိုင့်များ",
	"userProfile.nav.header.viewProfile": "ကျွန်ုပ်၏ ကိုယ်ရေးအချက်အလက်ကို ကြည့်မည်။",
	"userProfile.nav.menu.accountSettings": "အကောင့်ဆက်တင်",
	"userProfile.nav.menu.dataPrivacy": "ဒေတာကိုမူပိုင်မှု",
	"userProfile.nav.menu.disableAccount": "အကောင့်ဖျက်မယ်။",
	"userProfile.nav.menu.help": "အကူအညီ",
	"userProfile.nav.menu.logout": "ထွက်မယ်။",
	"userProfile.nav.menu.password": "စကားဝှက်",
	"userProfile.userRank.ambassador": "ကိုယ်စားလှယ်",
	"userProfile.userRank.doctor": "ဆရာဝန်",
	"userProfile.userRank.expert": "ကျွမ်းကျင်ပညာရှင်",
	"userProfile.userRank.influencer": "နာမည်ကြီး ထင်ရှားသူ",
	"userProfile.userRank.member": "အဖွဲ့ဝင်",
	"validation.error.requiredAgeGroup": "Your child is not in the required age group",
	"validation.error.requiredField": "ဒီနေရာမှာ ဖြည့်ဖို့ လိုအပ်ပါတယ်",
	"verifyBotAnswer.confirmEndorse.accept": "Yes, endorse",
	"verifyBotAnswer.confirmEndorse.cancel": "No, cancel",
	"verifyBotAnswer.confirmEndorse.description": "Thank you for endorsing the answer",
	"verifyBotAnswer.confirmEndorse.heading": "Endorse this answer"
};

export { character, copied, copy, myTranslations as default, insert, loading, orCopyLink, submit };
